<template>
<body class="u-body u-xl-mode" data-lang="en"><header class="u-clearfix u-header u-valign-bottom-sm u-valign-bottom-xs u-header" id="sec-52d1"><a href="#" class="u-image u-logo u-image-1" data-image-width="498" data-image-height="505" title="Home">
        <img src="../../../assets/warranty-images/logo-anewday_1full_color.webp" class="u-logo-image u-logo-image-1">
      </a><nav class="u-menu u-menu-one-level u-offcanvas u-menu-1">
        <div class="menu-collapse u-custom-font" style="font-size: 1.125rem; letter-spacing: 0px; font-family: Kanit;">
          <a class="u-button-style u-custom-left-right-menu-spacing u-custom-padding-bottom u-custom-top-bottom-menu-spacing u-nav-link u-text-active-palette-1-base u-text-hover-palette-2-base" href="#">
            <svg class="u-svg-link" viewBox="0 0 24 24"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#menu-hamburger"></use></svg>
            <svg class="u-svg-content" version="1.1" id="menu-hamburger" viewBox="0 0 16 16" x="0px" y="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><g><rect y="1" width="16" height="2"></rect><rect y="7" width="16" height="2"></rect><rect y="13" width="16" height="2"></rect>
</g></svg>
          </a>
        </div>
        <div class="u-custom-menu u-nav-container">
          <ul class="u-custom-font u-nav u-unstyled u-nav-1"><li class="u-nav-item"><a class="u-button-style u-nav-link u-text-active-palette-1-base u-text-hover-palette-2-base" href="https://anewday.co.th" style="padding: 10px 20px;">Home</a>
</li><li class="u-nav-item"><a class="u-button-style u-nav-link u-text-active-palette-1-base u-text-hover-palette-2-base" href="https://anewday.co.th/en/shop/" style="padding: 10px 20px;">Products</a>
</li></ul>
        </div>
        <div class="u-custom-menu u-nav-container-collapse">
          <div class="u-black u-container-style u-inner-container-layout u-opacity u-opacity-95 u-sidenav">
            <div class="u-inner-container-layout u-sidenav-overflow">
              <div class="u-menu-close"></div>
              <ul class="u-align-center u-nav u-popupmenu-items u-unstyled u-nav-2"><li class="u-nav-item"><a class="u-button-style u-nav-link" href="https://anewday.co.th">Home</a>
</li><li class="u-nav-item"><a class="u-button-style u-nav-link" href="https://anewday.co.th/en/shop/">Products</a>
</li></ul>
            </div>
          </div>
          <div class="u-black u-menu-overlay u-opacity u-opacity-70"></div>
        </div>
      </nav></header>
    <section class="u-align-center u-clearfix u-image u-shading u-section-1" src="" data-image-width="1920" data-image-height="775" id="sec-aa94">
      <div class="u-clearfix u-sheet u-sheet-1">
        <p class="u-custom-font u-large-text u-text u-text-variant u-text-1">Warranty Terms</p>
        <h1 class="u-custom-font u-text u-title u-text-2">Black <span class="u-text-custom-color-1">Hole</span>
        </h1>
      </div>
    </section>
    <section class="u-align-center u-clearfix u-white u-section-2" id="carousel_f90e">
      <div class="u-clearfix u-sheet u-sheet-1">
        <h2 class="u-custom-font u-text u-text-custom-color-1 u-text-1"> Black Hole&nbsp;Warranty Terms</h2>
        <div class="u-accordion u-align-left u-collapsed-by-default u-faq u-spacing-10 u-accordion-1">
          <div class="u-accordion-item">
            <a @click="showone" class="u-accordion-link u-active-grey-5 u-button-style u-custom-font u-grey-5 u-hover-custom-color-1 u-accordion-link-1" id="link-accordion-f600" aria-controls="accordion-f600" aria-selected="false">
              <span class="u-accordion-link-text">1. The warranty period for all mosquito trap goods provide by the company in brands&nbsp;</span><span class="u-accordion-link-icon u-icon u-text-active-white u-text-hover-white u-icon-1"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 426.66667 426.66667" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-b6d8"></use></svg><svg class="u-svg-content" viewBox="0 0 426.66667 426.66667" id="svg-b6d8"><path d="m405.332031 192h-170.664062v-170.667969c0-11.773437-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031 9.558594-21.332031 21.332031v170.667969h-170.667969c-11.773437 0-21.332031 9.558594-21.332031 21.332031 0 11.777344 9.558594 21.335938 21.332031 21.335938h170.667969v170.664062c0 11.777344 9.558594 21.335938 21.332031 21.335938 11.777344 0 21.335938-9.558594 21.335938-21.335938v-170.664062h170.664062c11.777344 0 21.335938-9.558594 21.335938-21.335938 0-11.773437-9.558594-21.332031-21.335938-21.332031zm0 0"></path></svg></span>
            </a>
            <div v-if="is_show_one" id="accordion-f600" aria-labelledby="link-accordion-f600">
              <div class="u-container-layout u-container-layout-1">
                <div class="fr-view u-clearfix u-rich-text u-text">
                  <p id="isPasted">
                    <span class="u-custom-font" style="font-family: Kanit; font-size: 1rem; font-weight: 300;">The warranty period for all mosquito trap goods provide by the </span>
                    <span style="font-size: 1rem;">
                      <span class="u-custom-font" style="font-family: Kanit; font-weight: 300;">company in brands; Black Hole and/or Mosquito Magnet under imported and distributed by A New Day Co., Ltd. is 1 year from the date of purchase that presented on the receipt (Except for Master Trap 2 models, 6 months warranty). The company is willing to replace or repair it free of charge. </span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="u-accordion-item">
            <a @click="showtwo" class="u-accordion-link u-active-grey-5 u-button-style u-custom-font u-grey-5 u-hover-custom-color-1 u-accordion-link-2" id="link-accordion-72f4" aria-controls="accordion-72f4" aria-selected="false">
              <span class="u-accordion-link-text"> 2. In case of the product is defected or damaged from the production process within 14 days</span><span class="u-accordion-link-icon u-icon u-text-active-white u-text-hover-white u-icon-2"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 426.66667 426.66667" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-b250"></use></svg><svg class="u-svg-content" viewBox="0 0 426.66667 426.66667" id="svg-b250"><path d="m405.332031 192h-170.664062v-170.667969c0-11.773437-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031 9.558594-21.332031 21.332031v170.667969h-170.667969c-11.773437 0-21.332031 9.558594-21.332031 21.332031 0 11.777344 9.558594 21.335938 21.332031 21.335938h170.667969v170.664062c0 11.777344 9.558594 21.335938 21.332031 21.335938 11.777344 0 21.335938-9.558594 21.335938-21.335938v-170.664062h170.664062c11.777344 0 21.335938-9.558594 21.335938-21.335938 0-11.773437-9.558594-21.332031-21.335938-21.332031zm0 0"></path></svg></span>
            </a>
            <div v-if="is_show_two" id="accordion-72f4" aria-labelledby="link-accordion-72f4">
              <div class="u-container-layout u-container-layout-2">
                <div class="fr-view u-clearfix u-rich-text u-text">
                  <p id="isPasted">
                    <span class="u-custom-font" style="font-family: Kanit; font-weight: 300;">In case of the product is defected or damaged from the production process within 14 days after receiving the product, the company will replace the product for the customer according to the terms of the store. (Additional charges like shipping fees may apply, subject to Shop’s rules and conditions).</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="u-accordion-item">
            <a @click="showthree" class="u-accordion-link u-active-grey-5 u-button-style u-custom-font u-grey-5 u-hover-custom-color-1 u-accordion-link-3" id="link-accordion-854e" aria-controls="accordion-854e" aria-selected="false">
              <span class="u-accordion-link-text"> 3. In case of manufacturing defects of production standards or defective parts inside the machine&nbsp;</span><span class="u-accordion-link-icon u-icon u-text-active-white u-text-hover-white u-icon-3"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 426.66667 426.66667" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-4779"></use></svg><svg class="u-svg-content" viewBox="0 0 426.66667 426.66667" id="svg-4779"><path d="m405.332031 192h-170.664062v-170.667969c0-11.773437-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031 9.558594-21.332031 21.332031v170.667969h-170.667969c-11.773437 0-21.332031 9.558594-21.332031 21.332031 0 11.777344 9.558594 21.335938 21.332031 21.335938h170.667969v170.664062c0 11.777344 9.558594 21.335938 21.332031 21.335938 11.777344 0 21.335938-9.558594 21.335938-21.335938v-170.664062h170.664062c11.777344 0 21.335938-9.558594 21.335938-21.335938 0-11.773437-9.558594-21.332031-21.335938-21.332031zm0 0"></path></svg></span>
            </a>
            <div v-if="is_show_three" id="accordion-854e" aria-labelledby="link-accordion-854e">
              <div class="u-container-layout u-container-layout-3">
                <div class="fr-view u-clearfix u-rich-text u-text">
                  <p id="isPasted">
                    <span class="u-custom-font" style="font-family: Kanit; font-weight: 300;">In case of manufacturing defects of production standards or defective parts inside the machine, the company will repair and replace spare parts with free of charge. This warranty does not include any damages arising from transportation, improper handling, misuse and improper maintenance, accident, negligence, use of non-standard power supply, electric current leakage, variability of electrical power system, &nbsp;fire, earthquake, flood, lightning, natural disasters, and/or other force majeure.</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="u-accordion-item u-expanded-width">
            <a @click="showfour" class="u-accordion-link u-active-grey-5 u-button-style u-custom-font u-grey-5 u-hover-custom-color-1 u-accordion-link-4" id="link-accordion-f600" aria-controls="accordion-f600" aria-selected="false">
              <span class="u-accordion-link-text">4. Warranty is subjected to unit being used for its intended purposes within the covered period&nbsp;</span><span class="u-accordion-link-icon u-icon u-text-active-white u-text-hover-white u-icon-4"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 426.66667 426.66667" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-1e29"></use></svg><svg class="u-svg-content" viewBox="0 0 426.66667 426.66667" id="svg-1e29"><path d="m405.332031 192h-170.664062v-170.667969c0-11.773437-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031 9.558594-21.332031 21.332031v170.667969h-170.667969c-11.773437 0-21.332031 9.558594-21.332031 21.332031 0 11.777344 9.558594 21.335938 21.332031 21.335938h170.667969v170.664062c0 11.777344 9.558594 21.335938 21.332031 21.335938 11.777344 0 21.335938-9.558594 21.335938-21.335938v-170.664062h170.664062c11.777344 0 21.335938-9.558594 21.335938-21.335938 0-11.773437-9.558594-21.332031-21.335938-21.332031zm0 0"></path></svg></span>
            </a>
            <div v-if="is_show_four" id="accordion-f600" aria-labelledby="link-accordion-f600">
              <div class="u-container-layout u-container-layout-4">
                <div class="fr-view u-clearfix u-rich-text u-text">
                  <p id="isPasted">
                    <span class="u-custom-font" style="font-family: Kanit; font-weight: 300;">Warranty is subjected to unit being used for its intended purposes within the covered period. It will only be guaranteed for customers who register to claim product warranty according to the company's system or show a receipt of purchase from a distribution channel certified by the company by specifying the details of the product warranty clearly and completely which can be registered through various channels and the website of the company specified in the card informing the details of the product warranty inside the product packaging within a period not exceeding 30 days from the date of purchase.</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="u-accordion-item u-expanded-width">
            <a @click="showfive" class="u-accordion-link u-active-grey-5 u-button-style u-custom-font u-grey-5 u-hover-custom-color-1 u-accordion-link-5" id="link-accordion-f600" aria-controls="accordion-f600" aria-selected="false">
              <span class="u-accordion-link-text"> 5. The buyer must bring the product to inspect or repair at the company by themselves with the original receipt attached&nbsp;</span><span class="u-accordion-link-icon u-icon u-text-active-white u-text-hover-white u-icon-5"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 426.66667 426.66667" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-58d2"></use></svg><svg class="u-svg-content" viewBox="0 0 426.66667 426.66667" id="svg-58d2"><path d="m405.332031 192h-170.664062v-170.667969c0-11.773437-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031 9.558594-21.332031 21.332031v170.667969h-170.667969c-11.773437 0-21.332031 9.558594-21.332031 21.332031 0 11.777344 9.558594 21.335938 21.332031 21.335938h170.667969v170.664062c0 11.777344 9.558594 21.335938 21.332031 21.335938 11.777344 0 21.335938-9.558594 21.335938-21.335938v-170.664062h170.664062c11.777344 0 21.335938-9.558594 21.335938-21.335938 0-11.773437-9.558594-21.332031-21.335938-21.332031zm0 0"></path></svg></span>
            </a>
            <div v-if="is_show_five" id="accordion-f600" aria-labelledby="link-accordion-f600">
              <div class="u-container-layout u-container-layout-5">
                <div class="fr-view u-clearfix u-rich-text u-text u-text-6">
                  <p id="isPasted">
                    <span class="u-custom-font" style="font-family: Kanit;">
                      <span class="u-custom-font" style="font-family: Kanit; font-weight: 300; font-size: 1rem;">The buyer must bring the product to inspect or repair at the company by themselves with the original receipt attached. This can be sent through dealers or sent directly to service centers. The buyer agrees to be responsible for the cost of shipping for repairs.</span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="u-accordion-item u-expanded-width">
            <a @click="showsix" class="u-accordion-link u-active-grey-5 u-button-style u-custom-font u-grey-5 u-hover-custom-color-1 u-accordion-link-6" id="link-accordion-f600" aria-controls="accordion-f600" aria-selected="false">
              <span class="u-accordion-link-text"> 6. Warranty will not be activated if&nbsp;</span><span class="u-accordion-link-icon u-icon u-text-active-white u-text-hover-white u-icon-6"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 426.66667 426.66667" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-ebfd"></use></svg><svg class="u-svg-content" viewBox="0 0 426.66667 426.66667" id="svg-ebfd"><path d="m405.332031 192h-170.664062v-170.667969c0-11.773437-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031 9.558594-21.332031 21.332031v170.667969h-170.667969c-11.773437 0-21.332031 9.558594-21.332031 21.332031 0 11.777344 9.558594 21.335938 21.332031 21.335938h170.667969v170.664062c0 11.777344 9.558594 21.335938 21.332031 21.335938 11.777344 0 21.335938-9.558594 21.335938-21.335938v-170.664062h170.664062c11.777344 0 21.335938-9.558594 21.335938-21.335938 0-11.773437-9.558594-21.332031-21.335938-21.332031zm0 0"></path></svg></span>
            </a>
            <div v-if="is_show_six" id="accordion-f600" aria-labelledby="link-accordion-f600">
              <div class="u-container-layout u-container-layout-6">
                <div class="fr-view u-clearfix u-rich-text u-text u-text-7">
                  <p id="isPasted">
                    <span class="u-custom-font" style="font-family: Kanit; font-weight: 300; font-size: 1rem;">&nbsp; &nbsp; 6.1 Customer does not submit information to request warranty claims or register through various channels and/or the company's website within 30 days from the date of purchase.</span>
                  </p>
                  <p>
                    <span class="u-custom-font" style="font-family: Kanit; font-weight: 300; font-size: 1rem;">&nbsp; &nbsp; 6.2 In case there are changes to the ownership or possession of unit from the original buyer, sender’s name must be the same person who filled out the warranty request form sent to the company. Otherwise, warranty will not be valid.</span>
                  </p>
                  <p>
                    <span class="u-custom-font" style="font-family: Kanit; font-weight: 300; font-size: 1rem;">&nbsp; &nbsp; 6.3 Damaged or parts removed from unit are due to DIY repairing o by other Company, other than by our company. There is a repair or disassembly of the machine to be modified or modified by a person who is not assigned by the company. For example, replacing UVA bulb.</span>
                  </p>
                  <p>
                    <span class="u-custom-font" style="font-family: Kanit; font-weight: 300; font-size: 1rem;">&nbsp; &nbsp; 6.4 In the case of using spare parts for other products such as lamps that are counterfeit-imitation products. This results in the failure of other parts of the Black Hole product and/or Mosquito Magnet.</span>
                  </p>
                  <p>
                    <span class="u-custom-font" style="font-family: Kanit; font-weight: 300; font-size: 1rem;">&nbsp; &nbsp; 6.5 Replacement or repair products must have a Warranty Void Sticker. All items must have Serial No. attached to the product in perfect quality.</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="u-accordion-item u-expanded-width">
            <a @click="showseven" class="u-accordion-link u-active-grey-5 u-button-style u-custom-font u-grey-5 u-hover-custom-color-1 u-accordion-link-7" id="link-accordion-f600" aria-controls="accordion-f600" aria-selected="false">
              <span class="u-accordion-link-text"> 7. This warranty coverage is restricted to Thailand only&nbsp;</span><span class="u-accordion-link-icon u-icon u-text-active-white u-text-hover-white u-icon-7"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 426.66667 426.66667" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-74bd"></use></svg><svg class="u-svg-content" viewBox="0 0 426.66667 426.66667" id="svg-74bd"><path d="m405.332031 192h-170.664062v-170.667969c0-11.773437-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031 9.558594-21.332031 21.332031v170.667969h-170.667969c-11.773437 0-21.332031 9.558594-21.332031 21.332031 0 11.777344 9.558594 21.335938 21.332031 21.335938h170.667969v170.664062c0 11.777344 9.558594 21.335938 21.332031 21.335938 11.777344 0 21.335938-9.558594 21.335938-21.335938v-170.664062h170.664062c11.777344 0 21.335938-9.558594 21.335938-21.335938 0-11.773437-9.558594-21.332031-21.335938-21.332031zm0 0"></path></svg></span>
            </a>
            <div v-if="is_show_seven" id="accordion-f600" aria-labelledby="link-accordion-f600">
              <div class="u-container-layout u-container-layout-7">
                <div class="fr-view u-clearfix u-rich-text u-text u-text-8">
                  <p id="isPasted">
                    <span class="u-custom-font" style="font-family: Kanit; font-weight: 300; font-size: 1rem;">This warranty coverage is restricted to Thailand only. Call 02-725-0839</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    
    <footer class="u-clearfix u-footer u-grey-80" id="sec-3f03"><div class="u-clearfix u-sheet u-sheet-1">
        <div class="u-align-left u-social-icons u-spacing-10 u-social-icons-1">
          <a class="u-social-url" target="_blank" data-type="Custom" title="Line" href="https://line.me/R/ti/p/%40blackholethailand"><span class="u-file-icon u-icon u-social-custom u-social-icon u-icon-1"><img src="../../../assets/warranty-images/3670089.png" alt=""></span>
          </a>
          <a class="u-social-url" title="facebook" target="_blank" href="https://www.facebook.com/blackholethailand/"><span class="u-icon u-social-facebook u-social-icon u-icon-2"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-5e5c"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-5e5c"><circle fill="currentColor" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M73.5,31.6h-9.1c-1.4,0-3.6,0.8-3.6,3.9v8.5h12.6L72,58.3H60.8v40.8H43.9V58.3h-8V43.9h8v-9.2
            c0-6.7,3.1-17,17-17h12.5v13.9H73.5z"></path></svg></span>
          </a>
          <a class="u-social-url" title="instagram" target="_blank" href="https://www.instagram.com/blackholethailand/"><span class="u-icon u-social-icon u-social-instagram u-icon-3"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-4e65"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-4e65"><circle fill="currentColor" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M55.9,38.2c-9.9,0-17.9,8-17.9,17.9C38,66,46,74,55.9,74c9.9,0,17.9-8,17.9-17.9C73.8,46.2,65.8,38.2,55.9,38.2
            z M55.9,66.4c-5.7,0-10.3-4.6-10.3-10.3c-0.1-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3C66.2,61.8,61.6,66.4,55.9,66.4z"></path><path fill="#FFFFFF" d="M74.3,33.5c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2S76.6,33.5,74.3,33.5z"></path><path fill="#FFFFFF" d="M73.1,21.3H38.6c-9.7,0-17.5,7.9-17.5,17.5v34.5c0,9.7,7.9,17.6,17.5,17.6h34.5c9.7,0,17.5-7.9,17.5-17.5V38.8
            C90.6,29.1,82.7,21.3,73.1,21.3z M83,73.3c0,5.5-4.5,9.9-9.9,9.9H38.6c-5.5,0-9.9-4.5-9.9-9.9V38.8c0-5.5,4.5-9.9,9.9-9.9h34.5
            c5.5,0,9.9,4.5,9.9,9.9V73.3z"></path></svg></span>
          </a>
          <a class="u-social-url" title="twitter" target="_blank" href="https://twitter.com/blackholeTH2017"><span class="u-icon u-social-icon u-social-twitter u-icon-4"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-e7f2"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-e7f2"><circle fill="currentColor" class="st0" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M83.8,47.3c0,0.6,0,1.2,0,1.7c0,17.7-13.5,38.2-38.2,38.2C38,87.2,31,85,25,81.2c1,0.1,2.1,0.2,3.2,0.2
            c6.3,0,12.1-2.1,16.7-5.7c-5.9-0.1-10.8-4-12.5-9.3c0.8,0.2,1.7,0.2,2.5,0.2c1.2,0,2.4-0.2,3.5-0.5c-6.1-1.2-10.8-6.7-10.8-13.1
            c0-0.1,0-0.1,0-0.2c1.8,1,3.9,1.6,6.1,1.7c-3.6-2.4-6-6.5-6-11.2c0-2.5,0.7-4.8,1.8-6.7c6.6,8.1,16.5,13.5,27.6,14
            c-0.2-1-0.3-2-0.3-3.1c0-7.4,6-13.4,13.4-13.4c3.9,0,7.3,1.6,9.8,4.2c3.1-0.6,5.9-1.7,8.5-3.3c-1,3.1-3.1,5.8-5.9,7.4
            c2.7-0.3,5.3-1,7.7-2.1C88.7,43,86.4,45.4,83.8,47.3z"></path></svg></span>
          </a>
          <a class="u-social-url" target="_blank" data-type="YouTube" title="YouTube" href="https://www.youtube.com/channel/UC5her_rmFbYJ_NtPL2AypvQ"><span class="u-icon u-social-icon u-social-youtube u-icon-5"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-b8fd"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-b8fd"><circle fill="currentColor" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M74.9,33.3H37.3c-7.4,0-13.4,6-13.4,13.4v18.8c0,7.4,6,13.4,13.4,13.4h37.6c7.4,0,13.4-6,13.4-13.4V46.7 C88.3,39.3,82.3,33.3,74.9,33.3L74.9,33.3z M65.9,57l-17.6,8.4c-0.5,0.2-1-0.1-1-0.6V47.5c0-0.5,0.6-0.9,1-0.6l17.6,8.9 C66.4,56,66.4,56.8,65.9,57L65.9,57z"></path></svg></span>
          </a>
        </div>
        <div class="u-expanded-width u-layout-grid u-list u-list-1">
          <div class="u-repeater u-repeater-1">
            <div class="u-align-left u-container-style u-custom-color-1 u-list-item u-radius-20 u-repeater-item u-shape-round u-list-item-1" data-animation-name="bounceIn" data-animation-duration="1500" data-animation-direction="Right" data-animation-delay="500">
              <div class="u-container-layout u-similar-container u-container-layout-1">
                <h5 class="u-custom-font u-text u-text-1"><span class="u-file-icon u-icon u-text-white"><img src="../../../assets/warranty-images/597177-de35359a.png" alt=""></span>&nbsp;Call Us
                </h5>
                <p class="u-text u-text-2">
                  <a class="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-hover-palette-1-base u-text-white u-btn-1" href="tel:02-725-0841"> 02-725-0841</a>
                </p>
              </div>
            </div>
            <div class="u-align-left u-container-style u-custom-color-1 u-list-item u-radius-20 u-repeater-item u-shape-round u-list-item-2" data-animation-name="bounceIn" data-animation-duration="1500" data-animation-direction="Right" data-animation-delay="500">
              <div class="u-container-layout u-similar-container u-container-layout-2">
                <h5 class="u-custom-font u-text u-text-3"><span class="u-file-icon u-icon"><img src="../../../assets/warranty-images/email-icons-white-color-958812.jpg" alt=""></span>&nbsp;Email
                </h5>
                <p class="u-custom-font u-text u-text-4">
                  <a class="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-hover-palette-1-base u-text-white u-btn-2" href="mailto:online@anewday.co.th"> online@anewday.co.th</a>
                </p>
              </div>
            </div>
            <div class="u-align-left u-container-style u-custom-color-1 u-list-item u-radius-20 u-repeater-item u-shape-round u-list-item-3" data-animation-name="bounceIn" data-animation-duration="1500" data-animation-direction="Right" data-animation-delay="500">
              <div class="u-container-layout u-similar-container u-container-layout-3">
                <h5 class="u-custom-font u-text u-text-5"><span class="u-file-icon u-icon u-text-white"><img src="../../../assets/warranty-images/484167-0f572cc8.png" alt=""></span> A New Day Co.,Ltd 
                </h5>
                <p class="u-custom-font u-text u-text-6">
                  <a class="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-hover-palette-1-base u-text-white u-btn-3" href="https://www.google.com/maps?ll=13.775506,100.596097&amp;z=20&amp;t=m&amp;hl=en&amp;gl=TH&amp;mapclient=embed&amp;cid=6701663887302958155"> 634/4 Soi. Ramkhamheang 39 ( Theplila 1 ), Phachautit Rd., Wangthonglang, Bangkok 10310 Thailand </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div></footer>
    <!--<section class="u-backlink u-clearfix u-grey-80">
      <a class="u-link" href="https://nicepage.com/website-templates" target="_blank">
        <span>Website Templates</span>
      </a>
      <p class="u-text">
        <span>created with</span>
      </p>
      <a class="u-link" href="" target="_blank">
        <span>Website Builder Software</span>
      </a>. 
    </section><span style="height: 64px; width: 64px; margin-left: 0px; margin-right: auto; margin-top: 0px; background-image: none; right: 20px; bottom: 20px; padding: 15px;" class="u-back-to-top u-icon u-icon-circle u-opacity u-opacity-85 u-palette-1-base" data-href="#">
        <svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 551.13 551.13"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-1d98"></use></svg>
        <svg class="u-svg-content" enable-background="new 0 0 551.13 551.13" viewBox="0 0 551.13 551.13" xmlns="http://www.w3.org/2000/svg" id="svg-1d98"><path d="m275.565 189.451 223.897 223.897h51.668l-275.565-275.565-275.565 275.565h51.668z"></path></svg>
    </span>--->
  
</body>
</template>

<script>
export default {
  created(){
    document.title = "A New Day Warranty"
  }, 
  data() {
    return {
      // show
      is_show_one : false,
      is_show_two: false,
      is_show_three : false,
      is_show_four : false,
      is_show_five : false,
      is_show_six : false,
      is_show_seven : false,
    }
  },
  methods: {
    async showone(){
      if (this.is_show_one == false){
        this.is_show_one = true
        this.is_show_two = false
        this.is_show_three = false
        this.is_show_four = false
        this.is_show_five = false
        this.is_show_six = false
        this.is_show_seven = false
      }else{
        this.is_show_one = false
      }
    },
    async showtwo(){
      if (this.is_show_two == false){
        this.is_show_two = true
        this.is_show_one = false
        this.is_show_three = false
        this.is_show_four = false
        this.is_show_five = false
        this.is_show_six = false
        this.is_show_seven = false
      }else{
        this.is_show_two = false
      }
    },
    async showthree(){
      if (this.is_show_three == false){
        this.is_show_three = true
        this.is_show_one = false
        this.is_show_two = false
        this.is_show_four = false
        this.is_show_five = false
        this.is_show_six = false
        this.is_show_seven = false
      }else{
        this.is_show_three = false
      }
    },
    async showfour(){
      if (this.is_show_four == false){
        this.is_show_four = true
        this.is_show_one = false
        this.is_show_two = false
        this.is_show_three = false
        this.is_show_five = false
        this.is_show_six = false
        this.is_show_seven = false
      }else{
        this.is_show_four = false
      }
    },
    async showfive(){
      if (this.is_show_five == false){
        this.is_show_five = true
        this.is_show_one = false
        this.is_show_two = false
        this.is_show_three = false
        this.is_show_four = false
        this.is_show_six = false
        this.is_show_seven = false
      }else{
        this.is_show_five = false
      }
    },
    async showsix(){
      if (this.is_show_six == false){
        this.is_show_six = true
        this.is_show_one = false
        this.is_show_two = false
        this.is_show_three = false
        this.is_show_four = false
        this.is_show_five = false
        this.is_show_seven = false
      }else{
        this.is_show_six = false
      }
    },
    async showseven(){
      if (this.is_show_seven == false){
        this.is_show_seven = true
        this.is_show_one = false
        this.is_show_two = false
        this.is_show_three = false
        this.is_show_four = false
        this.is_show_five = false
        this.is_show_six = false
      }else{
        this.is_show_seven = false
      }
    }
  }
}
</script>

<style scoped>
 .u-section-1 {
  background-image: linear-gradient(0deg, rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url("../../../assets/warranty-images/banner-home1.webp");
  background-position: 50% 50%;
}

.u-section-1 .u-sheet-1 {
  min-height: 394px;
}

.u-section-1 .u-text-1 {
  font-size: 3rem;
  font-family: Kanit;
  font-weight: 600;
  margin: 96px 453px 0 0;
}

.u-section-1 .u-text-2 {
  font-family: Kanit;
  font-size: 3.75rem;
  font-weight: 700;
  margin: 25px 453px 60px 0;
}

@media (max-width: 1199px) {
  .u-section-1 .u-sheet-1 {
    min-height: 332px;
  }

  .u-section-1 .u-text-1 {
    width: auto;
    margin-top: 75px;
    margin-right: 370px;
  }

  .u-section-1 .u-text-2 {
    width: auto;
    margin-top: 20px;
    margin-right: 370px;
  }
}

@media (max-width: 991px) {
  .u-section-1 .u-sheet-1 {
    min-height: 297px;
  }

  .u-section-1 .u-text-1 {
    font-size: 2.25rem;
    margin-top: 70px;
    margin-right: 286px;
  }

  .u-section-1 .u-text-2 {
    font-size: 3rem;
    margin-top: 22px;
    margin-right: 286px;
  }
}

@media (max-width: 767px) {
  .u-section-1 .u-text-1 {
    margin-right: 196px;
  }

  .u-section-1 .u-text-2 {
    margin-right: 196px;
  }
}

@media (max-width: 575px) {
  .u-section-1 .u-sheet-1 {
    min-height: 270px;
  }

  .u-section-1 .u-text-1 {
    font-size: 1.5rem;
    margin-top: 73px;
    margin-right: 109px;
  }

  .u-section-1 .u-text-2 {
    font-size: 1.75rem;
    margin-top: 9px;
    margin-right: 102px;
  }
} .u-section-2 {
  background-image: none;
}

.u-section-2 .u-sheet-1 {
  min-height: 978px;
}

.u-section-2 .u-text-1 {
  font-family: Kanit;
  font-weight: 600;
  width: 637px;
  margin: 70px auto 0;
}

.u-section-2 .u-accordion-1 {
  width: 894px;
  margin: 49px auto 60px;
}

.u-section-2 .u-accordion-link-1 {
  background-image: none;
  font-size: 1.125rem;
  font-family: Kanit;
  font-weight: normal;
  padding: 25px 30px;
}

.u-section-2 .u-icon-1 {
  height: 17px;
  width: 17px;
  color: rgb(128, 128, 128);
}

.u-section-2 .u-accordion-pane-1 {
  min-height: 154px;
  background-image: none;
}

.u-section-2 .u-container-layout-1 {
  padding: 20px 30px;
}

.u-section-2 .u-accordion-link-2 {
  background-image: none;
  font-size: 1.125rem;
  font-family: Kanit;
  font-weight: normal;
  padding: 25px 30px;
}

.u-section-2 .u-icon-2 {
  height: 17px;
  width: 17px;
  color: rgb(128, 128, 128);
}

.u-section-2 .u-accordion-pane-2 {
  min-height: 154px;
  background-image: none;
}

.u-section-2 .u-container-layout-2 {
  padding: 20px 30px;
}

.u-section-2 .u-accordion-link-3 {
  background-image: none;
  font-size: 1.125rem;
  font-family: Kanit;
  font-weight: normal;
  padding: 25px 30px;
}

.u-section-2 .u-icon-3 {
  height: 17px;
  width: 17px;
  color: rgb(128, 128, 128);
}

.u-section-2 .u-accordion-pane-3 {
  min-height: 154px;
  background-image: none;
}

.u-section-2 .u-container-layout-3 {
  padding: 20px 30px;
}

.u-section-2 .u-accordion-link-4 {
  background-image: none;
  font-size: 1.125rem;
  font-family: Kanit;
  font-weight: normal;
  padding: 25px 30px;
}

.u-section-2 .u-icon-4 {
  height: 17px;
  width: 17px;
  color: rgb(128, 128, 128);
}

.u-section-2 .u-accordion-pane-4 {
  min-height: 154px;
  background-image: none;
}

.u-section-2 .u-container-layout-4 {
  padding: 20px 30px;
}

.u-section-2 .u-accordion-link-5 {
  background-image: none;
  margin-bottom: 0;
  font-size: 1.125rem;
  font-family: Kanit;
  font-weight: normal;
  padding: 25px 30px;
}

.u-section-2 .u-icon-5 {
  height: 17px;
  width: 17px;
  color: rgb(128, 128, 128);
}

.u-section-2 .u-accordion-pane-5 {
  min-height: 154px;
  background-image: none;
}

.u-section-2 .u-container-layout-5 {
  padding: 20px 30px;
}

.u-section-2 .u-text-6 {
  margin-bottom: 0;
  font-size: 1.125rem;
}

.u-section-2 .u-accordion-link-6 {
  background-image: none;
  margin-bottom: 0;
  font-size: 1.125rem;
  font-family: Kanit;
  font-weight: normal;
  padding: 25px 30px;
}

.u-section-2 .u-icon-6 {
  height: 17px;
  width: 17px;
  color: rgb(128, 128, 128);
}

.u-section-2 .u-accordion-pane-6 {
  min-height: 154px;
  background-image: none;
}

.u-section-2 .u-container-layout-6 {
  padding: 20px 30px;
}

.u-section-2 .u-text-7 {
  margin-bottom: 0;
  font-size: 1.125rem;
}

.u-section-2 .u-accordion-link-7 {
  background-image: none;
  margin-bottom: 0;
  font-size: 1.125rem;
  font-family: Kanit;
  font-weight: normal;
  padding: 25px 30px;
}

.u-section-2 .u-icon-7 {
  height: 17px;
  width: 17px;
  color: rgb(128, 128, 128);
}

.u-section-2 .u-accordion-pane-7 {
  min-height: 154px;
  background-image: none;
}

.u-section-2 .u-container-layout-7 {
  padding: 20px 30px;
}

.u-section-2 .u-text-8 {
  margin-bottom: 0;
  font-size: 1.125rem;
}

@media (max-width: 1199px) {
  .u-section-2 .u-accordion-pane-1 {
    height: auto;
  }

  .u-section-2 .u-accordion-pane-2 {
    height: auto;
  }

  .u-section-2 .u-accordion-pane-3 {
    height: auto;
  }

  .u-section-2 .u-accordion-pane-4 {
    height: auto;
  }

  .u-section-2 .u-accordion-pane-5 {
    height: auto;
  }
}

@media (max-width: 991px) {
  .u-section-2 .u-accordion-1 {
    width: 720px;
  }
}

@media (max-width: 767px) {
  .u-section-2 .u-text-1 {
    width: 540px;
  }

  .u-section-2 .u-accordion-1 {
    width: 540px;
  }

  .u-section-2 .u-container-layout-1 {
    padding-left: 20px;
    padding-right: 20px;
  }

  .u-section-2 .u-container-layout-2 {
    padding-left: 20px;
    padding-right: 20px;
  }

  .u-section-2 .u-container-layout-3 {
    padding-left: 20px;
    padding-right: 20px;
  }

  .u-section-2 .u-container-layout-4 {
    padding-left: 20px;
    padding-right: 20px;
  }

  .u-section-2 .u-container-layout-5 {
    padding-left: 20px;
    padding-right: 20px;
  }

  .u-section-2 .u-accordion-pane-6 {
    height: auto;
  }

  .u-section-2 .u-container-layout-6 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .u-section-2 .u-accordion-pane-7 {
    height: auto;
  }

  .u-section-2 .u-container-layout-7 {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (max-width: 575px) {
  .u-section-2 .u-text-1 {
    width: 340px;
  }

  .u-section-2 .u-accordion-1 {
    width: 340px;
  }
}
</style>
